    function asddd()
    {
        const connection = Empower.ConnectionPool.client({
            client: 'browser',
            server: 'side',
            instanceId: 1,
            cb: Foo
        })
    }
    function str2ab(str)
    {
        return new TextEncoder().encode(str);
    }
    function ab2base64(buf)
    {
        return btoa(String.fromCharCode(...new Uint8Array(buf)));
    }
    function base642ab(b64)
    {
        const s = atob(b64);
        const arr = new Uint8Array(s.length);
        for (let i = 0; i < s.length; i++)
        {
            arr[i] = s.charCodeAt(i);
        }
        return arr.buffer;
    }
    async function encrypt(str, keyStr)
    {
        const rawKey = str2ab(keyStr);
        const fixedKey = new Uint8Array(16);
        fixedKey.set(rawKey);
        const iv = crypto.getRandomValues(new Uint8Array(12));
        const key = await crypto.subtle.importKey(
            'raw',
            fixedKey,
            { name: 'AES-GCM' },
            true,
            ['encrypt']
        );
        const data = str2ab(str);
        const encrypted = await crypto.subtle.encrypt(
            { name: 'AES-GCM', iv },
            key,
            data
        );
        const out = new Uint8Array(iv.length + encrypted.byteLength);
        out.set(iv);
        out.set(new Uint8Array(encrypted), iv.length);
        return ab2base64(out);
    }
    async function decrypt(str, keyStr)
    {
        const buf = base642ab(str);
        const arr = new Uint8Array(buf);
        const iv = arr.slice(0, 12);
        const cipher = arr.slice(12);
        const rawKey = str2ab(keyStr);
        const fixedKey = new Uint8Array(16);
        fixedKey.set(rawKey);
        const key = await crypto.subtle.importKey(
            'raw',
            fixedKey,
            { name: 'AES-GCM' },
            false,
            ["decrypt"]
        );
        const dec = await crypto.subtle.decrypt(
            { name: 'AES-GCM', iv },
            key,
            cipher
        )
        return new TextDecoder().decode(dec);
    }
    export async function generateKey()
    {
        function toPem(base64) {
            let ret = '';
            for (let i = 0; i < base64.length; i += 64) {
                ret += base64.slice(i, i + 64);
            }
            return ret;
        }
        const keyPair = await crypto.subtle.generateKey(
            {
                name: 'RSASSA-PKCS1-v1_5',
                modulusLength: 1024,
                publicExponent: new Uint8Array([1, 0, 1]),
                hash: 'SHA-256'
            },
            true,
            ['sign', 'verify']
        );
        const pubRaw = await crypto.subtle.exportKey('spki', keyPair.publicKey);
        const publicKeyPem = toPem(ab2base64(pubRaw));
        const priRaw = await crypto.subtle.exportKey('pkcs8', keyPair.privateKey);
        const privateKeyPem = toPem(ab2base64(priRaw));
        const username = localStorage.getItem('user-name');
        localStorage.setItem('codigger-symbol', await encrypt(privateKeyPem, username));
        return publicKeyPem;
    }
    export async function getSignature(method = 'portal')
    {
        try
        {
            const username = localStorage.getItem('user-name');
            const privateKey1 = localStorage.getItem('codigger-symbol');
            if (!privateKey1) return undefined;
            const privateKey2 = await decrypt(privateKey1, username);
            const privateKey3 = await crypto.subtle.importKey(
                'pkcs8',
                base642ab(privateKey2),
                { name: 'RSASSA-PKCS1-v1_5', hash: 'SHA-256' },
                false,
                ['sign']
            )
            const obj = {
                username,
                method,
                timestamp: Date.now()
            }
            const data = new TextEncoder().encode(JSON.stringify(obj));
            const signature = await crypto.subtle.sign(
                { name: 'RSASSA-PKCS1-v1_5', saltLength: 32 },
                privateKey3,
                data
            )
            const signBase64 = ab2base64(signature);
            return `${signBase64}.${btoa(JSON.stringify(obj))}`;
        }
        catch (err)
        {
            console.log(err);
            return undefined;
        }
    }

